export const HTTP_LOADING_EVENT = "shark-status:http-loading";

let pendingRequests = 0;

function emitLoading(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(HTTP_LOADING_EVENT, {
      detail: { pending: pendingRequests },
    }),
  );
}

export function getPendingHttpRequests(): number {
  return pendingRequests;
}

export async function http<T>(url: string, init?: RequestInit): Promise<T> {
  pendingRequests += 1;
  emitLoading();
  try {
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        ...(init?.headers ?? {}),
      },
      ...init,
    });

    const contentType = response.headers.get("content-type") ?? "";
    const isJSON = contentType.toLowerCase().includes("application/json");

    if (!response.ok) {
      const body = await response.text();
      if (isJSON) {
        try {
          const parsed = JSON.parse(body) as { error?: string };
          if (parsed.error) throw new Error(parsed.error);
        } catch {
          // Fall back to plain text message below.
        }
      }
      throw new Error(body || `request failed: ${response.status}`);
    }

    if (response.status === 204) {
      return undefined as T;
    }

    if (!isJSON) {
      const body = await response.text();
      const sample = body.replace(/\s+/g, " ").trim().slice(0, 140);
      const hint =
        (contentType || "").toLowerCase().includes("text/html") ||
        (sample && sample.toLowerCase().startsWith("<!doctype"))
          ? " Ensure /api/v1/* is routed to the status backend and, if using a path prefix, that base_path is set."
          : "";
      throw new Error(
        `Status API returned a page instead of data (got ${contentType || "unknown content type"}${sample ? `: ${sample}` : ""}).${hint}`,
      );
    }

    return (await response.json()) as T;
  } finally {
    pendingRequests = Math.max(0, pendingRequests - 1);
    emitLoading();
  }
}
